export default __webpack_public_path__ + "1008b5226941c24f44681061d347ad5e.woff2";